export default __webpack_public_path__ + "static/amstel-ab4d4626be2dd379d3828db139125980.jpg";